<template>
	<div class="nakladnoyWholesale">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
						}}
					</b-button>
				</div>
				<div class="pull-right">

<!--					<a style="font-size: 16px;" class="mr-3" :href="`${root_api}/excel-parser/nakladnoy/${item.id}`" disabled-->
<!--									download>{{ $t('excel-export.download-excel') }}</a>-->
					<b-button
						variant="outline-dark"
						@click="submitPricePrint"
						class="mr-2"
					>
						<i class="fa fa-print"></i>
						{{ $t('incomes.create.prices')}}
					</b-button>
<!--			<b-button-->
<!--			variant="outline-dark"-->
<!--			@click="generateBarcode"-->
<!--			class="mr-2"-->
<!--			v-if="item.documentStatus === 'READY'"-->
<!--			>-->
<!--			<i class="fa fa-print"></i>-->
<!--			{{$t('pricing.print')}} {{$t('goods.barcode')}}-->
<!--			</b-button>-->
					<!--<button id="btnExport" @click="fnExcelReport('tableForExcel')"> EXPORT </button>-->
					<b-button
						variant="outline-dark"
						@click="print"
						class="mr-2"
					>
						<i class="fa fa-print"></i>
						{{ $t('Печать')}}
					</b-button>
				</div>
				<div class="clearfix"></div>


			</div>
		<div class="doc-body">
			<b-card
				:class="[showUpperPartOfDoc ? '' : 'mt']"
				style="padding-top: 40px; padding-left: 50px; padding-right: 20px; padding-bottom: 20px"
			>
				<table style="width: 100%">
					<thead class="mb-3">
					<tr>
						<th>
							<div class="row">
								<div class="col-md-4">

								</div>
								<div class="col-md-4">
									<p class="text-center">
										Накладная передачи
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-md-4">
									<table>
										<tr>
											<td>Номер</td>
											<td><b>{{item.regNumber}}</b></td>
											<td>Откуда</td>
											<td><b>{{item.fromDepartmentName}}</b></td>
										</tr>
										<tr>
											<td>Дата</td>
											<td><b>{{item.regDate}}</b></td>
											<td>Куда</td>
											<td><b>{{item.toDepartmentName}}</b></td>
										</tr>
									</table>
								</div>
							</div>
						</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td>
							<div class="mb-3" id="nakladnoyTableWrapper">
								<table class="table table-striped" id="tableForExcel" style="font-size: 15px">
									<tr id="dutyFreeItemsHeader">
										<th class="p-1 textAlignCenter" style="width: 3%">
											№
										</th>
										<th class="p-1 textAlignCenter">
											Спец-код
										</th>
										<th class="p-1">
											Наименование
										</th>
										<th class="p-1 text-center" style="width: 10%">
											Штрих-код
										</th>
										<th class="p-1 textAlignCenter">
											Кол-во
										</th>
										<th class="p-1 textAlignCenter">
											Цена
										</th>
										<th class="p-1 textAlignCenter">
											Сумма
										</th>
									</tr>

									<tbody>
									<tr v-for="(item, index) in item.whItems" class="docItemRow" :key="index"  v-if="item.count > 0">
										<td class="text-center">
											{{ index + 1 }}
										</td>
										<td class="text-center">{{ item.barcode }}</td>
										<td>
											{{ item.itemName }}
										</td>
										<td class="text-center">
											<p v-for="(barcode, k) in item.multiBarcodes" :key="k">
												{{ barcode.barcode }}
											</p>
										</td>
										<td class="customSizeItem text-center">
											{{ item.count }} <sup>{{ item.unitName }}</sup>
										</td>
										<td class="text-center">
											{{ item.priceUzs | currency({
											symbol: ' ', fractionCount: 2, symbolPosition: 'back'
										}) }}
										</td>
										<td class="text-center">
								<span class="text-center">{{ (item.priceUzs * item.count) | currency({
									symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}</span>
										</td>
									</tr>
									</tbody>

									<tr>
										<td colspan="4" style="font-weight: bold; text-align: right">
											Итого
										</td>
										<td class="text-center">
								<span v-if="totalCountItems > 0" style="font-weight: bold">
									{{ totalCountItems }}
								</span>
										</td>
										<td></td>
										<td class="text-center">
								<span v-if="totalPriceOfItems > 0" style="font-weight: bold">
									{{ totalPriceOfItems | currency({
									symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
								</span>
										</td>
									</tr>
								</table>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</td>
					</tr>
					</tbody>
<!--					<tfoot class="nakladnoyFooter">-->
<!--					<tr>-->
<!--						<td>-->
<!--							<table style="width: 100%;">-->
<!--								<tr>-->
<!--									<td colspan="2">Требование составил _______________________________</td>-->
<!--									<td>"Утверждаю"</td>-->
<!--								</tr>-->
<!--								<tr>-->
<!--									<td>Отпустил ______________________________</td>-->
<!--									<td>Принял ______________________________</td>-->
<!--									<td>______________________________</td>-->
<!--								</tr>-->
<!--								<tr>-->
<!--									<td colspan="2"></td>-->
<!--									<td>Tolipov N.</td>-->
<!--								</tr>-->
<!--								<tr>-->
<!--									<td colspan="2"></td>-->
<!--									<td>______________________________</td>-->
<!--								</tr>-->
<!--								<tr>-->

<!--									<td>Zakirov O. Z.</td>-->
<!--								</tr>-->
<!--								<tr>-->
<!--									<td colspan="2" class="text-right">______________________________</td>-->
<!--									<td>______________________________</td>-->
<!--								</tr>-->
<!--								<tr>-->
<!--									<td colspan="2" class="text-right">Ф.И.О</td>-->
<!--									<td><div class="row">-->
<!--										<div class="col-6 ">-->
<!--											подпись-->
<!--										</div>-->
<!--										<div class="col-6 ">-->
<!--										</div>-->
<!--									</div></td>-->
<!--								</tr>-->
<!--							</table>-->
<!--						</td>-->
<!--					</tr>-->
<!--					</tfoot>-->
				</table>
			</b-card>
		</div>
    <b-modal
      :title="$t('barcode-count')"
      v-model="confirmBarcodeGenerate"
      size="lg"
    >

      <table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">

        <tr>
          <th>&#9745;</th>
          <th style="width: 30px;text-align: center">№</th>
          <th>{{$t('sidebar.warehouse-management.products')}}</th>
          <th colspan="2">{{$t('goods.amount')}}</th>
          <!--<th style="width: 230px;">Количество</th>-->
        </tr>

        <tr  cols="12" v-for="(calculateCount,index) in currentWhItems">
          <td>
            <b-checkbox v-model="calculateCount.checked"></b-checkbox>
          </td>
          <td style="text-align: center">
          {{index + 1}}
          </td>
          <td>{{calculateCount.itemName}} / <strong> {{calculateCount.artikul}} </strong>/ {{calculateCount.color}} /{{calculateCount.size}}
            <strong>{{calculateCount.barcode}}</strong></td>
          <td>
            <b-col>
              <b-input-group size="sm">
                <b-form-input v-model="calculateCount.count"
                        size="sm" autocomplete="off" type="number"
                        :disabled="!calculateCount.checked"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </td>
        </tr>
      </table>

      <div slot="modal-footer">
        <b-button
          variant="success"
          size="sm"
          class="float-right ml-2"
          @click="submitBarcodeGenerate"
        >
          {{$t('save')}}
        </b-button>

        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="cancelBarcodeGenerate"
        >
          {{$t('cancel')}}
        </b-button>
      </div>
    </b-modal>


		<b-modal v-model="pricePrint" size="lg" :title="$t('incomes.create.prices')">

			<b-table
				:items="priceWhItems"
				:fields="priceCols"
				selectable
				ref="priceSelectedItems"
			>
				<template slot="index" slot-scope="data">
					{{ data.index+1 }}
				</template>
				<template slot="multiBarcodesString" slot-scope="data">
					<div v-for="barcode in data.item.multiBarcodesString">
						{{ barcode }}
					</div>
				</template>
			</b-table>

			<div slot="modal-footer">
				<b-button
					variant="success"
					size="sm"
					class="float-right ml-2"
					@click="submitPricePrint"
				>
					{{$t('save')}}
				</b-button>

				<b-button
					variant="primary"
					size="sm"
					class="float-right"
					@click="pricePrint = false"
				>
					{{$t('cancel')}}
				</b-button>
			</div>
		</b-modal>
    <!-- <vs-sidebar :click-not-close="true"
          position-right
          parent="body"
          default-index="1"
          color="primary"
          class="create-modal"
          spacer
          v-model="sidebar.open">
      <b-container index="1" v-if="sidebar.open">
        <create-form
          :mode="'edit'"
          :edit-item="item"
          @close="sidebar.open = false"
          @reload="get"
        ></create-form>
      </b-container>
    </vs-sidebar> -->
	</div>

</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import WhDocument from "../../../../services/wh-document.service";
  import moment from 'moment'
  import UsersService from "../../../../services/users.sevice";
  import EmployeeSerive from "../../../../services/employees.service";
  import CreateForm from "../blocks/CreateForm";
  import MaskedInput from 'vue-masked-input'
	export default {
		name: 'TNakladnoy',
		render(h) {
			return h(this.tag, this.is)
		},
		data() {
			return {
				pricePrint: false,
				changePrice: false,
				showUpperPartOfDoc: true,
				seriaBarcodeConfirmed: false,
				seriaForBarcodeGenerate: '',
				root_api: process.env.VUE_APP_ROOT_API,
				vatPercentage: null,
				is: {type:String, required:true},
				loader: false,
				item: {},
				totalPrice: {
				uzs: 0,
				usd: 0,
				saleTypePrice: 0,
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
				uzs: 0,
				usd: 0
				},
				confirmBarcodeGenerate: false,
				barcodeCount:0,
				currentWhItems:[],
				priceWhItems:[],
				priceCols: [
					{key: 'index', label: '№', class: 'text-center'},
					{key: 'itemName', label: this.$t('goods.name')},
					{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
					{key: 'multiBarcodesString', label: this.$t('goods.barcode'), class: 'text-center'},
					{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'}
				],
				// sidebar: {
				//   open: false,
				//   close: false
				// },
				backTo: null,
				tag5: 'span',
				tag6: 'span',
				tag7: 'span',
				tag4:'span',
				tag81:'span',
				tag82:'span',
				tag83:'span',
				tag9:'span',
				tagNdsTranspartor: 'span',
				tag31:'span',
				tag32:'span',
				tag33:'span',
				tag0101:'span',
				tag0202:'span'
				}
		},

methods: {
	resetSeriaBarcodeInput () {
		this.seriaBarcodeConfirmed = false;
	},
		generateBarcodeForSeria($event) {
			if ($event.target.value.trim() == '') {
				return 0;
			}
			this.seriaForBarcodeGenerate = $event.target.value
			this.seriaBarcodeConfirmed = true;
		},
		async excelNakladnoyApi() {
			await WhDocument.excelNakladnoyTransfer(this.$route.params.id)
		},
		async blurFivePunct(number, payload) {
			switch(number) {
				case '5':
				payload.loadingPoint = this.$refs.fiveRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag5 = 'span'
				break;
				case '6':
				payload.unloadingPoint = this.$refs.sixRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag6 = 'span'
				break;
				case '7':
				payload.redirects = this.$refs.sevenRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag7 = 'span'
				break;
				case '4':
				payload.nakladnoyAttachedDocs = this.$refs.fourRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag4 = 'span'
				break;
				case '82':
				payload.seria = this.$refs.seriaRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag82 = 'span'
				break
				case '81':
				payload.waybill = this.$refs.waybillRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag81 = 'span'
				break
				case '83':
				payload.nakladnoyDate = this.$refs.nakladnoyDateRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag83 = 'span'
				break;
				case '9':
				payload.transportator = this.$refs.transportatorRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag9  = 'span'
				break;
				case 'ndsTranspartor':
				payload.ndsTranspartor = this.$refs.ndsTranspartorRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tagNdsTranspartor  = 'span'
				break;
				case '31':
				payload.nakladnoyPowerOfAttorney = this.$refs.nakladnoyPowerOfAttorneyRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag31  = 'span'
				break;
				case '32':
				payload.nakladnoyDelegateDate = this.$refs.nakladnoyDelegateDateRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag32  = 'span'
				break;
				case '33':
				payload.nakladnoyDelegate = this.$refs.nakladnoyDelegateRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag33  = 'span'
				break

				case '0101':
				payload.date2 = this.$refs.date2Ref.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag0101  = 'span'
				break

				case '0202':
				payload.regDate = this.$refs.regDateRef.value;
				await WhDocument.editTransferDoc(this.$route.params.id, payload)
				await this.get()
				await this.getDepartmentInfo('toDep');
				await this.getDepartmentInfo()
				this.tag0202  = 'span'
				break
				}
			},
		changePunctFive(number) {
				switch(number) {
				case '5':
					if(this.tag5 !== 'input') {
						this.tag5 = 'input'
						setTimeout(() => {
						this.$refs.fiveRef.focus()
						}, 100)
					}
				break;
				case '6':
					if(this.tag6 !== 'input') {
						this.tag6 = 'input'
						setTimeout(() => {
						this.$refs.sixRef.focus()
						}, 100)
					}
				break;
				case '7':
					if(this.tag7 !== 'input') {
						this.tag7 = 'input'
						setTimeout(() => {
						this.$refs.sevenRef.focus()
						}, 100)
					}
				break;
				case '4':
					if(this.tag4 !== 'input') {
						this.tag4 = 'input'
						setTimeout(() => {
						this.$refs.fourRef.focus()
						}, 100)
					}
				break;

				case '81':
					if(this.tag81 !== 'input') {
						this.tag81 = 'input'
						setTimeout(() => {
						this.$refs.waybillRef.focus()
						}, 100)
					}
				break;

				case '82':
					if(this.tag82 !== 'input') {
						this.tag82 = 'input'
						setTimeout(() => {
						this.$refs.seriaRef.focus()
						}, 100)
					}
				break;

				case '83':
					if(this.tag83 !== 'input') {
						this.tag83 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyDateRef.focus()
						}, 100)
					}
				break;
				case '9':
					if(this.tag9 !== 'input') {
						this.tag9 = 'input'
						setTimeout(() => {
						this.$refs.transportatorRef.focus()
						}, 100)
					}
				break;
				case 'ndsTranspartor':
					if(this.tagNdsTranspartor !== 'input') {
						this.tagNdsTranspartor = 'input'
						setTimeout(() => {
							this.$refs.ndsTranspartorRef.focus()
						}, 100)
					}
				break;
				case '31':
					if(this.tag31 !== 'input') {
						this.tag31 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyPowerOfAttorneyRef.focus()
						}, 100)
					}
				break;
				case '32':
					if(this.tag32 !== 'input') {
						this.tag32 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyDelegateDateRef.focus()
						}, 100)
					}
				break;
				case '33':
					if(this.tag33 !== 'input') {
						this.tag33 = 'input'
						setTimeout(() => {
						this.$refs.nakladnoyDelegateRef.focus()
						}, 100)
					}
				break;
				case '0101':
					if(this.tag0101 !== 'masked-input') {
						this.tag0101 = 'masked-input'
						setTimeout(() => {
						this.$refs.date2Ref.$el.focus()
						}, 100)
					}
				break;
				case '0202':
					if(this.tag0202 !== 'masked-input') {
						this.tag0202 = 'masked-input'
						setTimeout(() => {
						this.$refs.regDateRef.$el.focus()
						}, 100)
					}
				break;
			}
		},
      // openSidebar() {
      //   setTimeout(() => {
      //     this.sidebar.open = true
      //   }, 200)
      // },
      ...mapActions('warehouse', [
        'setCurrentWhItems', 'setPriceWhItems'
      ]),
      cancelBarcodeGenerate(){
        this.confirmBarcodeGenerate = false;
      },
      submitBarcodeGenerate(){
        let items = {};
        items.status = true;
        items.data = this.currentWhItems.filter(column => column.checked === true );
        items.data.forEach((item,index) => {
          items.data[index].count = parseInt(item.count)
        });
        this.setCurrentWhItems(items);
        this.$router.push(`/warehouse-management/income/barcodes`);
    	},
      generateBarcode() {
        //this.currentWhItems = Object.assign({}, this.item.whItems);
        this.currentWhItems =JSON.parse(JSON.stringify(this.item.whItems));
        this.confirmBarcodeGenerate = true;
        //this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

      },
	generatePrice() {
		this.priceWhItems = JSON.parse(JSON.stringify(this.item.whItems));
		this.pricePrint = true
	},
	submitPricePrint() {
		let items = {};
		items.status = true;
		items.data = JSON.parse(JSON.stringify(this.item.whItems));
		items.data.forEach((item,index) => {
			items.data[index].count = parseInt(item.count)
		});
		this.setPriceWhItems(items);
		this.$router.push(`/warehouse-management/price/print`);
	},
      get() {
        if (this.$can('get', 'warehouse-document')) {
          this.loader = true;
          return WhDocument.get(this.$route.params.id).then(response => {
            this.loader = false;
            this.item = response.data;
            this.sumPrice(this.item);
            this.sumIncome(this.item);
          }).catch(error => {
            this.loader = false
          })
        }
	  },
		getDepartmentInfo(whichDep) {
        if (this.$can('get', 'warehouse-document')) {
		  this.loader = true;
		  if (whichDep == 'toDep') {
			  return WhDocument.getDeparmentForDocument(this.item.toDepartmentId).then(res => {
				this.loader = false;
				this.toVatPercentage = res.data.vatPercentage
				// this.item.fromAddress = res.data.address
				this.item.toCb = res.data.cb
				this.item.toBankFilialName = res.data.bankFilialName
				this.item.toBankName = res.data.bankName
				// this.item.fromBankAccount = res.data.bankAccount
				this.item.toAddress = res.data.address
				this.item.toBankAccount = res.data.bankAccount
				// this.item = response.data;
				// this.sumPrice(this.item);
				// this.sumIncome(this.item);
			}).catch(error => {
				this.loader = false
			})
		  }
          return WhDocument.getDeparmentForDocument(this.item.fromDepartmentId).then(res => {
			this.loader = false;
			this.vatPercentage = res.data.vatPercentage
			this.item.fromAddress = res.data.address
			this.item.cb = res.data.cb
			this.item.bankFilialName = res.data.bankFilialName
			this.item.bankName = res.data.bankName
			this.item.fromBankAccount = res.data.bankAccount
			// this.item.toAddress = res.data.address
			// this.item.toBankAccount = res.data.bankAccount
            // this.item = response.data;
            // this.sumPrice(this.item);
            // this.sumIncome(this.item);
          }).catch(error => {
            this.loader = false
          })
        }
      },
      sumPrice(item) {
        if (typeof item.whItems === 'object') {
          Object.values(item.whItems).map(item => {
            if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
            if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
            if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
          });
        }
      },
      sumIncome(item) {
        if (typeof item.whItems === 'object') {
          Object.values(item.whItems).map(item => {
            this.totalIncome.usd += item.incomingPriceUsd * item.count;
            this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
          });
        }
      },
		goBackToFrom() {
			this.$router.back();
		},
			print() {
				window.print();
			},

			// tableToExcel(table, name) {
			// 	var uri = 'data:application/vnd.ms-excel;base64,'
			// 		,
			// 		template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
			// 		, base64 = function (s) {
			// 			return window.btoa(unescape(encodeURIComponent(s)))
			// 		}
			// 		, format = function (s, c) {
			// 			return s.replace(/{(\w+)}/g, function (m, p) {
			// 				return c[p];
			// 			})
			// 		}
			//
			// 	if (!table.nodeType) table = document.getElementById(table)
			// 	var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
			// 	return window.location.href = uri + base64(format(template, ctx))
			//
			// },


			tableToExcel(tableID) {
				var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
				var textRange = "<p text-align=''";
				var j = 0;
				let tab = document.getElementById(tableID); // id of table

				for (j = 0; j < tab.rows.length; j++) {
					tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
					//tab_text=tab_text+"</tr>";
				}

				tab_text = tab_text + "</table>";
				tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
				tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
				// tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

				var ua = window.navigator.userAgent;
				var msie = ua.indexOf("MSIE ");

				if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
				{
					txtArea1.document.open("txt/html", "replace");
					txtArea1.document.write(tab_text);
					txtArea1.document.close();
					txtArea1.focus();
					var sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
				} else                 //other browser not tested on IE 11
					sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

				return (sa);
			},


			excelExport(tableID, filename = '') {

				let downloadLink;

				let dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				let tableSelect = document.getElementById(tableID);
				let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					let blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}
			},
			calculateRealCostOfItem(item) {
				/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
				let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
				if (this.changePrice) {
					if (item.priceUzs == item.saleTypePrice) {
						if (item.priceWholesale > 0) {
							return item.priceWholesale * item.count;
						} else {
							return 0;
						}
					} else {
						if (item.priceUzs > 0) {
							return item.priceUzs * item.count;
						} else {
							return 0;
						}
					}
				} else {
					if (item.saleTypePrice > 0) {
						return item.saleTypePrice* item.count;
					} else {
						return 0
					}
				}
			},
			calculateNdsOfItem(item) {
				return this.calculateRealCostOfItem(item) / 6;
			},
			calculateSumOfItemWithoutNds(item) {
				return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
			},
			calculatePriceWithoutNds(item) {
				return this.calculateSumOfItemWithoutNds(item) / item.count;
			},
			calculateTotalRealCost() {
				let temp = 0;
				if(this.item.whItems) {
        			  for (let i = 0; i < this.item.whItems.length; i++) {
							temp += this.calculateRealCostOfItem(this.item.whItems[i]);
						}
				}
				return temp;
			}
		},
		async created() {
			  await this.get()
			  await this.getDepartmentInfo('toDep');
			  await this.getDepartmentInfo('fromDep');
		},
		computed: {
			totalPriceOfItems() {
				let temp = 0;
				if(this.item.whItems) {
				this.item.whItems.forEach(el => {
							temp += (el.priceUzs * el.count);
						});
				}
				return temp;
			},
			totalCountItems() {
				let temp = 0;
				if(this.item.whItems) {
					this.item.whItems.forEach(el => {
						temp += el.count;
					});
				}
				return temp;
			},
			totalNdsOfItems() {
				let temp = 0;
        if(this.item.whItems) {
          this.item.whItems.forEach(el => {
          temp += this.calculateNdsOfItem(el);
        });
        }
				return temp;
			}
		},
    components: {
		MaskedInput,
        CreateForm
    },
	}
</script>

<style scoped>

</style>
<style scoped lang="scss">

@page  {
	margin: 1cm;
}

.spinner-wrapper {
  position: absolute;
  background: rgba(32, 28, 32, 0.49);
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  padding-top: 35px;
  z-index: 5;
}
	.nakladnoyWholesale {
		margin: 0 20px;
	}

	@media print {
		.hidden-print {
			display: none;
		}
		.mt {
			padding-top: 200px !important;
				}
		.card {
			box-shadow: none;
		}
		#nakladnoyTableWrapper {
			display: block;
		}
	}

	.saldoInfoTexts {
		width: 88%;

		span {
			display: inline-block;
			width: 18%;
		}

		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 80%;
		}

		/*input.bottomBorderedInput:focus {
		border-color: green
		}*/
	}


	.signsOfAccountants {
		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 40%;
		}

		p {
			width: 40%;

			&.sign {
				text-align: center;
				font-size: 12px;
			}
		}
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	h6.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	#nakladnoyTableWrapper {
		.table {
			td, th {
				border: 1px solid black;
				vertical-align: middle;

				&.borderRightNone {
					border-right: none;
				}

				&.borderLeftNone {
					border-left: none;
				}

				&.borderTopNone {
					border-top: none;
				}

				&.borderBottomNone {
					border-bottom: none;
				}

				color: black;
			}

			#moldavianItemsHeader {
				th {
					font-size: 9px;
					border-bottom: none;
				}
				.width27 {
					width: 27%;
				}
			}

			#russianItemsHeader {
				th {
					font-size: 9px;
					border-top: none;
				}

				.greyText {
					color: #999999;
				}
			}

			.docItemRow {
				td {
					padding: 0 .5rem;
				}
			}

			th {
				font-size: 14px;
			}
			td {
				font-size: 13px !important;
			}



			.moldavianText {
				font-weight: bold;
			}

			.fontWeightNormal {
				font-weight: normal;
			}

			//tfoot {
			//	th, td {
			//		font-weight: bold;
			//		font-size: 13px;
			//		text-align: right;
			//
			//		&.textAlignCenter {
			//			text-align: center;
			//		}
			//
			//		&:first-child {
			//			text-align: unset;
			//		}
			//
			//		padding: 0 .5rem;
			//	}
			//}

			.nakladnoyFooter {
				margin-top: 15px !important;
			}
			tfoot {
				margin-top: 15px !important;
			}
		}
	}
	.customSize {
		font-size: 10px;
	}
	.customSizeItem {
		font-size: 12px;
	}
	.nobr {
		white-space: nowrap;
	}

	.strong {
		font-weight: bold;
	}
#docUpperPart {
	p {
		margin-bottom: 0;
	}
	margin-bottom: .5rem;
	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}
	#docImgLogo {
		width: 180px;
		height: 70px;
	}
	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;
			p {
				display: inline-block;
			}
		}
		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;
			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;
				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}
		display: inline-block;
		width: 74%;
		#seriaInputForBarcode {
			display: inline-block;
			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}
	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;
		#rightPartTxt {
			font-size: 10px;
		}
	}
}


</style>
